import { Grid } from "@mui/material";
import AcxHierarchySelector from "components/UI/AcxHierarchySelector/AcxHierarchySelector";
import AcxDialog from "components/UI/Dialog/AcxDialog";
import React, { useRef, useState } from "react";
import { AuthStore } from "stores/AuthStore";
import { useStore } from "utils/useStore";
import { Suggestion } from "../Suggestions/Suggestion";
import AcxButton from "components/UI/AcxButton";
import RecursiveTreeStore from "components/UI/AcxRecursiveTree/Stores/AcxRecursiveTreeStore";
import { observer } from "mobx-react";
import { ActionProps } from "./Actions";
import { useCurrentChatStore } from "components/KBo/Stores/useCurrentChat";

export const SelectHierarchiesAction: React.FC<ActionProps> = observer(
    ({ args }) => {
        const authStore = useStore(AuthStore);
        const currentChatStore = useCurrentChatStore();
        const [dialogOpen, setDialogOpen] = useState(false);
        const treeStoreRef = useRef<RecursiveTreeStore | null>(null);

        return (
            <React.Fragment>
                <AcxDialog
                    isOpen={dialogOpen}
                    onClose={() => {
                        setDialogOpen(false);
                    }}
                    title="Hierarchies"
                    dialogContentChildren={
                        <AcxHierarchySelector
                            displayType="baseOnly"
                            orgId={
                                authStore.orgStore.selectedOrganization?.id ??
                                ""
                            }
                            userId={authStore._user.profile.sub}
                            setHierarchyIds={() => void 0}
                            onSaveUpdateWithHierarchies={() => void 0}
                            hideBottomContent
                            treeStoreGetter={(ts) =>
                                (treeStoreRef.current = ts)
                            }
                        />
                    }
                >
                    <AcxButton
                        fullWidth={false}
                        onClick={() => {
                            const treeStore = treeStoreRef.current;
                            if (!treeStore) {
                                return;
                            }

                            const userMessage =
                                (args?.displayedMessagePrefix || "") +
                                treeStore.selectedBranchLabels.join(", ");
                            const selectedHierarchies =
                                treeStore.selectedBranchIds.map((id, index) => ({
                                    hierarchyId: id,
                                    hierarchyName:
                                        treeStore.selectedBranchLabels[index],
                                }));
                            const input =
                                (args?.llmMessagePrefix ||
                                    "The user wants new data using a different set of hierarchies than previously requested. The hierarchies to use in your filters are: ") +
                                JSON.stringify(selectedHierarchies);
                            

                            let serverAction = args?.serverAction;
                            if (serverAction) {
                                let args = { ...serverAction.arguments, input };
                                serverAction = {
                                    ...serverAction,
                                    arguments: args,
                                };
                            }

                            const additionalInformation = {
                                DisplayMessage: userMessage,
                            };

                            currentChatStore?.streamingSubmitInput({
                                manualInput: input,
                                userMessage: userMessage,
                                serverAction: serverAction,
                                additionalInformation: additionalInformation,
                            });
                        }}
                    >
                        Use selected hierarchies
                    </AcxButton>
                </AcxDialog>
                <Grid item>
                    <Suggestion onClick={() => setDialogOpen((open) => !open)}>
                        {args?.buttonText || "Select Hierarchies"}
                    </Suggestion>
                </Grid>
            </React.Fragment>
        );
    },
);
